import type React from "react";
import { useParams } from "react-router-dom";

const EventDetailPage: React.FC = () => {
	const { eventId } = useParams<{ eventId: string }>();

	return (
		<div className="space-y-6">
			<h1 className="text-3xl font-bold">イベント詳細</h1>
			<div className="bg-white p-6 rounded-lg shadow">
				{/* イベント詳細を表示するコンポーネントをここに配置 */}
			</div>
			<div className="bg-white p-6 rounded-lg shadow">
				<h2 className="text-xl font-semibold mb-4">参加者一覧</h2>
				{/* 参加者一覧を表示するコンポーネントをここに配置 */}
			</div>
			<button className="btn btn-primary">参加する</button>
		</div>
	);
};

export default EventDetailPage;
